<template>
  <div class="application-pcd-picker">
    <el-select v-model="province_code" placeholder="省" @change="city_code=''; county_code=''; changePcd()" class="pcd-picker">
      <el-option :label="v" :value="k" v-for="(v,k) in pcdData.pcds[86]" :key="k"></el-option>
    </el-select>

    <el-select v-model="city_code" placeholder="市" @change="county_code=''; changePcd()" class="pcd-picker">
      <el-option :label="v" :value="k" v-for="(v,k) in pcdData.pcds[province_code]" :key="k"></el-option>
    </el-select>

    <el-select v-if="!field.onlyCity" v-model="county_code" placeholder="区" @change="changePcd()" class="pcd-picker" :disabled="disableCountySelect">
      <el-option :label="v" :value="k" v-for="(v,k) in pcdData.pcds[city_code]" :key="k"></el-option>
    </el-select>
  </div>
</template>

<script>
import applicationFormService from '../../../services/application-form-service';

export default {
  name: 'application-pcd-picker',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    field: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    onlyCity: {
      type: Boolean,
      default: false,
    },
    fieldIndex: {
      type: Number,
      required: true,
      default: 0,
    },
    fieldDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    applicationData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    pcdData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      province_code: '',
      city_code: '',
      county_code: '',
    };
  },
  computed: {

    // 禁用区选择器
    disableCountySelect() {
      return Boolean(this.province_code) && Boolean(this.city_code) && !this.pcdData.pcds[this.city_code];
    },
  },
  methods: {

    // 省市区变化
    changePcd() {
      if (this.pcdData.pcds[86]) {
        const provinceName = this.province_code ? this.pcdData.pcds[86][this.province_code] : '';
        const cityName = this.city_code && provinceName ? this.pcdData.pcds[this.province_code][this.city_code] : '';
        const countyName = this.county_code && cityName ? this.pcdData.pcds[this.city_code][this.county_code] : '';
        let result = provinceName;

        // 注意这里的空格！，这个空格是给下面watch分割用的
        if (cityName) {
          result += ` ${cityName}`;
        }
        if (countyName) {
          result += ` ${countyName}`;
        }
        if (provinceName && cityName) {

          // 有些只需要选到城市
          if (this.field.onlyCity) {
            this.$emit('input', result);
          } else {

            // 禁用了说明没有区
            if (this.disableCountySelect) {
              this.$emit('input', result);
            } else {

              // 如果有区就必需选
              if (countyName) {
                this.$emit('input', result);
              } else {
                this.$emit('input', '');
              }
            }
          }
        } else {
          this.$emit('input', '');
        }
      }
    },

    // 响应外部设置数据
    setData(pcdData) {
      const [province_code, city_code, county_code] = applicationFormService.pcdNamesToCode(pcdData, this.pcdData.tranformedPcds);
      if (province_code) {
        this.province_code = province_code;
      }

      // 其实做下面模拟的原因是你每次设置一次省市区的province_code, city_code, county_code都会触发上面el-select的change事件,
      // 但是change事件中比如省清空了市和区,所以这里冲突了,所以这样蛋疼的解决
      if (city_code) {

        // 这里其实模拟的是用户下一次点击了市
        this.$nextTick(() => {
          this.city_code = city_code;

          // 又模拟点了区
          this.$nextTick(() => {
            if (county_code) {
              this.county_code = county_code;
            }
          });
        });
      }
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.setData(newValue);
      }
    },
  },
  created() {
    if (this.value) {
      this.setData(this.value);
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";
div.application-pcd-picker {
  display: flex;
  .pcd-picker {
    margin-left: 10px;
    flex: 1;
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/application/components/application-pcd-picker.vue